import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import ModalCertif from "./ModalCertif";
import AvisGoogle from "./AvisGoogle";
import * as styles from "./layout.module.css";
import { Script } from "gatsby";

type LayoutProps = {
  children: React.ReactNode;
};

/**
 * Ce composant enveloppait autrefois ses enfants dans <html><head><body>. Comme
 * il n'est monté qu'à l'intérieur de <div id="___gatsby">, ces balises se
 * retrouvaient imbriquées dans le corps du document : React les créait bien en
 * DOM, mais le <title> qu'elles portaient n'était le titre de rien, et le
 * <head> n'était pas le <head>. Gatsby a une place prévue pour ça — la Head API
 * dans chaque page, et gatsby-ssr.tsx pour ce qui doit précéder tout le reste.
 *
 * Le vrai coût était ailleurs : wrapPageElement n'était déclaré que dans
 * gatsby-browser, donc le HTML livré ne contenait ni menu ni pied de page. Ils
 * n'apparaissaient qu'une fois le JavaScript exécuté. gatsby-ssr.tsx déclare
 * désormais le même wrapper, et ce composant rend un fragment.
 */
export default function Layout({ children }: LayoutProps) {
  return (
    <>
      <div className="max-w-[1280px] mx-auto">
        <Navbar />
      </div>

      <div className={styles.maincontent}>{children}</div>

      <Footer />

      <ModalCertif />

      <AvisGoogle />

      {/* Les réglages Axeptio et les défauts Consent Mode sont posés en tête de
          <head> par gatsby-ssr.tsx. Il ne reste ici que le SDK lui-même, en
          `idle` : il part une fois la page chargée, pas pendant. Rien ne traque
          avant consentement, donc rien ne se perd à faire apparaître le bandeau
          une seconde plus tard — et le fil principal reste au rendu. */}
      <Script
        id="axeptio-sdk"
        strategy="idle"
        src="https://static.axept.io/sdk.js"
      />
    </>
  );
}
